import styled from 'styled-components';

export const StyledBundlePriceButton = styled.div.attrs({
  className: 'bundlePriceButton',
})`
  height: ${(props: any) => props?.height || '40px'};
  width: ${(props: any) => props?.width?.normal || '100%'};
  background: var(--button-bg-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props: any) => props.borderRadius};
  font-weight: 700;
  font-size: 16px;
  color: var(--button-text-color);
  position: relative;

  .white_stripe {
    position: absolute;
    top: 2px;
    height: 8px;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    );
  }

  @media (max-width: 374px) {
    height: 30px;
    width: ${(props: any) => props.width};
  }
` as any;

export const StyledBundlePrice = styled.div`
  display: flex;
  direction: ${(props: any) => props.direction};
  justify-content: center;
  width: 100%;
  color: var(--button-text-color);
  text-shadow: ${(props: any) => props.textShadow};

  .totalPrice {
    display: flex;
    align-items: center;
    line-height: 1;

    .actual-price {
      direction: ltr;
    }

    .availability {
      position: absolute;
      display: flex;
      justify-content: end;
      right: 10px;
      bottom: 9px;
      top: 8px;
      left: auto;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    .timeLeft {
      position: absolute;
      left: 10px;
      top: 8px;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
` as any;

export const StyledActualPrice = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  white-space: nowrap;
  font-weight: 700;
  line-height: 1;
  direction: ${(props: any) => props.direction};
  .final-price {
    display: flex;
    .actual-price {
      direction: ltr;
    }
  }
  span {
    text-shadow: ${(props: any) => props.textShadow};
  }
  .stroked {
    text-decoration-line: line-through;
    text-decoration-color: #d8232a;
    text-decoration-thickness: 1.5px;
    margin-right: ${(props: any) => (props.direction === 'rtl' ? '0' : '10px')};
    margin-left: ${(props: any) => (props.direction === 'rtl' ? '10px' : '0')};
    display: flex;
    align-items: center;
    font-size: 12px;
    span {
      text-shadow: none;
    }
    .actual-price {
      direction: ltr;
    }
  }
` as any;
